export default {
  productPageTitle: {
    id: 'buyback_product_page_title_meta_title',
    defaultMessage: 'Sell your {productName} with Trade-in | Earn {price}',
  },
}
